import { combineReducers } from "@reduxjs/toolkit";

import roundToJoinSlice from "../_V2/Pages/RoundToJoin/roundToJoin.slice";
import tokenSlice from "../_V2/Pages/RoundToJoin/tocken.slice";
import dashboard from "../_V2/Pages/Dashboard/dashboard.slice";
import choosePick from "../_V2/popups/choosePick.slice";
import voteNow from "../_V2/popups/votenow.slice";
import pickDetailSlice from "../_V2/Pages/PickDetail/pickDetail.slice";
import fixturesAndResults from "../_V2/Components/fixturesAndResult.slice";
import otpGTMSlice from '../_V2/popups/OtpGTM.slice';

const rootReducer = combineReducers({
  roundToJoin: roundToJoinSlice,
  token: tokenSlice,
  dashboard: dashboard,
  choosePick: choosePick,
  voteNow,
  pickDetail: pickDetailSlice,
  fixturesAndResults: fixturesAndResults,
  otpGTMSlice
});

export default rootReducer;
